import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M5 16.75c-.41 0-.75-.34-.75-.75V9c0-.41.34-.75.75-.75s.75.34.75.75v7c0 .41-.34.75-.75.75" }, null, -1),
    _createElementVNode("path", { d: "M5.25 9.25c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4m0-6.5a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 0 0-5M5 22.75c-2.07 0-3.75-1.68-3.75-3.75S2.93 15.25 5 15.25 8.75 16.93 8.75 19 7.07 22.75 5 22.75m0-6c-1.24 0-2.25 1.01-2.25 2.25S3.76 21.25 5 21.25 7.25 20.24 7.25 19 6.24 16.75 5 16.75M19 22.75c-2.07 0-3.75-1.68-3.75-3.75s1.68-3.75 3.75-3.75 3.75 1.68 3.75 3.75-1.68 3.75-3.75 3.75m0-6c-1.24 0-2.25 1.01-2.25 2.25s1.01 2.25 2.25 2.25 2.25-1.01 2.25-2.25-1.01-2.25-2.25-2.25" }, null, -1),
    _createElementVNode("path", { d: "M18.17 16.79a.75.75 0 0 1-.71-.5 5.23 5.23 0 0 0-4.94-3.51h-.02l-3.43.01h-.02c-2.19 0-4.1-1.48-4.65-3.6a.75.75 0 0 1 1.45-.37 3.305 3.305 0 0 0 3.2 2.48h.01l3.43-.01h.03a6.72 6.72 0 0 1 6.35 4.52.74.74 0 0 1-.46.95c-.08.01-.16.03-.24.03" }, null, -1)
  ]))]))
}
export default { render: render }